export const AdminLeaseListingDashboards = {
  AdminLeaseListingDashboards: 
  {
    permissionsId: '71b14c93-c3de-49b7-ee42-08da65738802',
    permissionsName: 'Admin Lease Listing Manager',
    componentsId: null,
    components: null
  }
} ;
